export { default as Img200 } from './processed/200/Equilibrium-448x252.jpg';
export { default as Img400 } from './processed/400/Equilibrium-448x252.jpg';
export { default as Imgthumb } from './processed/thumb/Equilibrium-448x252.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Equilibrium-448x252.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Equilibrium-448x252.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      35,
      132,
      190
    ],
    "_population": 52,
    "_hsl": [
      0.5623655913978495,
      0.688888888888889,
      0.4411764705882353
    ]
  },
  "LightVibrant": {
    "_rgb": [
      124,
      204,
      244
    ],
    "_population": 1,
    "_hsl": [
      0.5555555555555555,
      0.8450704225352117,
      0.7215686274509804
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      26,
      68,
      132
    ],
    "_population": 6,
    "_hsl": [
      0.60062893081761,
      0.6708860759493672,
      0.30980392156862746
    ]
  },
  "Muted": {
    "_rgb": [
      146,
      105,
      90
    ],
    "_population": 134,
    "_hsl": [
      0.04464285714285712,
      0.23728813559322026,
      0.4627450980392157
    ]
  },
  "LightMuted": {
    "_rgb": [
      163,
      161,
      188
    ],
    "_population": 15,
    "_hsl": [
      0.6790123456790123,
      0.1677018633540374,
      0.6843137254901961
    ]
  },
  "DarkMuted": {
    "_rgb": [
      50,
      56,
      81
    ],
    "_population": 175,
    "_hsl": [
      0.6344086021505376,
      0.2366412213740458,
      0.2568627450980392
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Equilibrium-448x252.js